import { apiClient } from '@/services/ApiClient.js'

export default {
  getMobileContacts(query) {
    return apiClient
      .get('mobile-contacts', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getMobileContact(id) {
    return apiClient
      .get('mobile-contacts/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  export(query) {
    return apiClient
      .get('mobile-contacts/export', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  cancelMobileContact(id) {
    return apiClient
      .delete('mobile-contacts/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
